import { ApplyTo, PricingSheetMeta, Status } from './constants';

export function getPricingSheetStatus(pricingSheet: PricingSheetMeta): Status {
  if (pricingSheet.draft) {
    return 'Draft';
  }
  if (pricingSheet.expiryDate) {
    if (new Date(pricingSheet.expiryDate) < new Date()) {
      return 'Expired';
    }
  }
  if (pricingSheet.startDate) {
    if (new Date(pricingSheet.startDate) > new Date()) {
      return 'Inactive';
    }
  }
  return pricingSheet.enabled ? 'Active' : 'Inactive';
}

export function getPricingSheetApplyTo(pricingSheet: PricingSheetMeta): ApplyTo {
  const hasGroups = (pricingSheet.customerGroups?.length ?? 0) > 0;
  const hasIndividuals = (pricingSheet.individualCustomers?.length ?? 0) > 0;
  if (hasGroups && hasIndividuals) {
    return 'Customer groups & individuals';
  }
  if (hasGroups) {
    return 'Specific customer groups';
  }
  if (hasIndividuals) {
    return 'Specific individuals';
  }
  return 'All customers';
}
